export default {
      id: "ic_deposit_money-usage",
      viewBox: "0 0 20 20",
      url: "/" + "images/icons.3.109.2.svg#ic_deposit_money-usage",
      toString: function () {
        return this.url;
      }
    }